const styles = {
  avatar: {
    fontSize: '50px',
    margin: '0 auto'
  },
  name: {
    color: '#777',
    fontWeight: 'bold',
    margin: '8px 0 40px',
    textAlign: 'center'
  }
}

export default styles
